<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #dcdde0',
    }"
  >
    <div class="question-type">问答</div>
    <div class="title-view">
      <!-- <span style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span
        >{{ `${index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
          <span
            style="
              position: relative;
              top: -2px;
              padding: 0 8px;
              line-height: 20px;
              background: rgba(58, 96, 255, 0.09);
              border: 1px solid rgba(58, 96, 255, 0.4);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 500;
              text-align: center;
              color: #3a60ff;
              display: inline-block;
              margin-left: 10px;
            "
          >
            {{ dataObj.questionScore ? dataObj.questionScore : "0" }}分
          </span>
        </span>
      </span> -->

      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
          <span
            style="
              position: relative;
              padding: 0 8px;
              line-height: 20px;
              background: rgba(58, 96, 255, 0.09);
              border: 1px solid rgba(58, 96, 255, 0.4);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 500;
              text-align: center;
              color: #3a60ff;
              display: inline-block;
              margin-left: 10px;
            "
          >
            {{ dataObj.questionScore ? dataObj.questionScore : "0" }}分
          </span>
        </span>
      </p>
    </div>
    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 20px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>
    <div
      :style="{ border: isFocus ? `1px solid ${color}` : '1px solid #EDEDED' }"
      class="textarea-view"
    >
      <el-input
        v-if="dataObj.status === 3 || dataObj.status === 4"
        type="textarea"
        v-model="context"
        placeholder="请输入"
        :autosize="{ minRows: 3 }"
        @focus="isFocus = true"
        @blur="handleTextareaBlur()"
        @input="handleInputChange"
        :disabled="dataObj.status !== 4 || showState === 10"
      ></el-input>
      <span v-else class="textarea-placeholder">请输入</span>
    </div>
    <div v-if="showAnswer">
      <div
        v-if="dataObj.ifRight"
        style="display: flex; align-items: center; margin-top: 20px"
      >
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335507420.svg"
          style="width: 16px; height: 16px"
        />
        <span class="correct-text">回答正确 +{{ dataObj.score }}分</span>
      </div>
      <div v-else style="display: flex; align-items: center; margin-top: 20px">
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335577224.svg"
          style="width: 16px; height: 16px"
        />
        <span class="error-text" style="font-size: 15px; font-weight: 500"
          >答错了 {{ dataObj.score > 0 ? `+${dataObj.score}分` : "" }}</span
        >
      </div>
      <div
        v-if="!dataObj.ifRight && dataObj.scoringMethod === 0"
        style="margin-top: 10px"
      >
        <span
          style="
            font-size: 15px;
            font-weight: 500;
            text-align: left;
            color: #00c755;
          "
          >正确答案</span
        >
        <div
          style="
            word-break: break-all;
            width: 100%;
            padding: 13px;
            box-sizing: border-box;
            background: #f7f7f7;
            border: 1px solid #ededed;
            border-radius: 3px;
            margin-top: 8px;
          "
        >
          {{ dataObj.chooseAnswer }}
        </div>
      </div>
      <div
        v-if="dataObj.scoringMethod !== 0"
        class="explanation-section"
        style="margin-top: 13px"
      >
        <span class="section-title">关键词</span>
        <div class="textarea-view">{{ dataObj.keyword || "暂无内容" }}</div>
      </div>
      <div class="explanation-section" style="margin-top: 10px">
        <span class="section-title" style="font-size: 15px; font-weight: 500"
          >答案解析</span
        >
        <div class="textarea-view">{{ dataObj.analysis || "暂无内容" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamPreviewQA",
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    showAnswer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      context: "",
      isFocus: false,
      color: "#3A60FF",
      images: [],
      index: 0,
      showState: 0,
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue && newValue.data) {
          this.dataObj = newValue.data;
          this.index = newValue.index;
          this.showState = newValue.state;
          this.images = JSON.parse(newValue.data.caseProblemImg || "[]");
          this.context = newValue.data.context;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleTextareaBlur() {
      this.isFocus = false;
    },
    handleInputChange() {
      const updatedData = {
        ...this.dataObj.data,
        context: this.context,
      };

      const answerObj = {
        question_id: this.dataObj.data.id,
        type: this.dataObj.data.type,
        if_hide: this.dataObj.data.if_hide,
        answer: [{ id: "", context: this.context }],
      };

      this.$emit(
        "update",
        JSON.stringify({
          data: updatedData,
          answer: answerObj,
          index: this.index,
        }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.textarea-view {
  height: 200px;
}

.question-container {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  // padding: 20px;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
  position: relative;
}

.title-view {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 15px;
  word-break: break-all;
  margin-top: 0;
  width: 90%;
}

.asterisk {
  color: #f73b42;
  margin-right: 4px;
}

.question-images {
  img {
    width: 100%;
    display: block;
    margin-top: 15px;
  }
}

.choose-css {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.choose-css-new {
  &:hover {
    opacity: 0.8;
  }
}

.choose-css-text {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.true-answer {
  font-size: 14px;
  color: #00c755;
  margin-right: 10px;
}

.correct-text {
  font-size: 15px;
  font-weight: 500;
  color: #00c755;
  margin-left: 8px;
}

.error-text {
  font-size: 15px;
  font-weight: 500;
  color: #f73b42;
  margin-left: 8px;
}

.explanation-section {
  margin-top: 20px;

  .section-title {
    font-size: 15px;
    font-weight: 500;
    color: #2b2f36;
    display: block;
    margin-bottom: 10px;
  }
}

.textarea-view {
  width: 100%;
  // min-height: 100px;
  // max-height: 200px;
  overflow-y: auto;
  // background: #f7f7f7;
  border: 1px solid #ededed;
  border-radius: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
  word-break: break-all;
  line-height: 1.6;
  text-align: left;
}

.textarea-placeholder {
  color: #c0c4cc;
}

.question-images-box {
  position: relative;
  cursor: pointer;
  margin-top: 15px;

  .thumbnail-image {
    width: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  .fangda-box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    text-align: center;
    padding: 8px;
    font-size: 12px;
    border-radius: 0 0 8px 8px;
  }
}

.fangda-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .popup-content {
    background: white;
    border-radius: 8px;
    padding: 20px;
    max-width: 90%;
    max-height: 90%;
    position: relative;

    .popup-guanbi {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      cursor: pointer;
    }

    .popup-scroll {
      max-height: 80vh;
      overflow-y: auto;

      img {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
}

.guanbi {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamPreview/ExamPreviewQA.vue